import React from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import Crumb from './Crumb';

const TypeCrumb = ({ href, translationKey }) => (
  <Crumb label={trans(translationKey)} href={href} position={3} />
);

TypeCrumb.propTypes = {
  href: PropTypes.string.isRequired,
  translationKey: PropTypes.string.isRequired
};

export default TypeCrumb;
